import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import Button from "@material-ui/core/Button";
import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Grid from "@material-ui/core/Grid";
import { createTheme } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { ThemeProvider } from "@material-ui/core/styles";
import { fetchVisits, fetchPatients, fetchAdmins } from "../actions/index";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import compose from "recompose/compose";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import SignatureCanvas from "react-signature-canvas";
import PainRelief from "../img/painReliefDiagram.jpg";
import InputMask from "react-input-mask";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Logo from "../img/logo.png";

import { generatePdf } from "../components/TreatmentNotesPDF";
import GetAppIcon from "@material-ui/icons/GetApp";

let url = process.env.REACT_APP_DOMAIN;

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const theme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: "#002BB8",
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
  },
});
const styles = (theme) => ({
  root: {
    width: "100%",
    // maxWidth: 500,
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  dense: {
    marginTop: 16,
  },
  menu: {
    width: 200,
  },
  exampleWrapper: {
    position: "relative",
    marginTop: theme.spacing(3),
    height: 380,
  },
  radioGroup: {
    margin: theme.spacing(1, 0),
  },
  speedDial: {
    position: "absolute",
    "&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft": {
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    "&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight": {
      top: theme.spacing(2),
      left: theme.spacing(2),
    },
  },
  rootDial: {
    transform: "translateZ(0px)",
    flexGrow: 1,
  },
});

class TreatmentNotes extends Component {
  constructor(props) {
    super(props);
    this.classes = props;
    this.state = {
      // admin view
      admin: false,
      tabStatus: 0,
      // treatment forms
      patient: "",
      visit: "",
      osteopathyTreatment: false,
      massageTreatment: false,
      acupunctureTreatment: false,
      naturopathicTreatment: false,
      osteoAssessment: false,
      acupunctureAssessment: false,
      // osteo treatment
      rocking: null,
      petrissage: null,
      friction: null,
      vibration: null,
      MyofacialRelease: null,
      tender: null,
      muscleEnergy: null,
      totalBody: null,
      stillTechnique: null,
      Craniosacral: null,
      Visceral: null,
      softTissue: null,
      stretch: null,
      intraOral: null,
      techniqueOther: null,
      back: null,
      neck: null,
      shoulders: null,
      face: null,
      leftArm: null,
      rightArm: null,
      leftLeg: null,
      rightLeg: null,
      gluteus: null,
      abdominals: null,
      chest: null,
      breast: null,
      areasOther: null,
      osteoNotes: null,
      // massage treatment
      Swedish: null,
      frictions: null,
      deepFacial: null,
      triggerPoints: null,
      stretchMassage: null,
      intraOralMassage: null,
      breastMassage: null,
      hydrotherapy: null,
      jointMobilization: null,
      grade: null,
      otherListMassage: null,
      backMassage: null,
      neckMassage: null,
      shouldersMassage: null,
      faceMassage: null,
      leftArmMassage: null,
      rightArmMassage: null,
      leftLegMassage: null,
      rightLegMassage: null,
      hipArea: null,
      abdominalsMassage: null,
      chestMassage: null,
      breastMassageMassage: null,
      areasOtherMassage: null,
      clinFinding: null,
      cliReaction: null,
      selfCare: null,
      // acu treatment
      progInqu: null,
      tongue: null,
      Pulse: null,
      Palpation: null,
      General: null,
      revisedDiag: null,
      // misc
      duration: null,
      // acupuncture assessment
      currentIllness: null,
      chiefComplaints: null,
      medicalHistory: null,
      tongueAssessment: null,
      PulseAssessment: null,
      PalpationAssessment: null,
      tcmDiagnosis: null,
      tcmTreatment: null,
      treatmentPlan: null,
      acupuncturePointsPrescription: null,
      adjunctModalities: null,
      herbal: null,
      // osteo assessment
      limitations: null,
      treatmentDiscussed: false,
      treatmentGoal: null,
      receivedConsent: null,
      typeTreatment: null,
      frequencyAssessment: null,
      assessmentsPerformed: null,
      anticipatedProgress: null,
      resultsOfAssessment: null,
      remedialExercises: null,
      reassessment: null,
      risksAssessment: null,
      backAssessment: null,
      neckAssessment: null,
      shouldersAssessment: null,
      faceAssessment: null,
      leftArmAssessment: null,
      rightArmAssessment: null,
      leftLegAssessment: null,
      rightLegAssessment: null,
      gluteusAssessment: null,
      abdominalsAssessment: null,
      chestAssessment: null,
      breastAssessment: null,
      areasOtherAssessment: null,
      loading: true,
      canSubmit: false,
      naturopathicSupplements: [{ supplement: "", dose: "", instructions: "" }],
      naturopathicRecommendations: null,
      naturopathicSubjective: null,
      naturopathicObjective: null,
      naturopathicAssessment: null,
      naturopathicPlan: null,
      // previous submissions
      submissionHistory: null,
      locked: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentWillMount = () => {
    this.setState({
      sigCanvas: {
        canvasWidth: 800,
        canvasHeight: 600,
      },
    });

    // Sets the values of tags in the head
    document.title = "Treatment Notes | Appleby Wellness";
    let metaTags = document.getElementsByTagName("meta");
    for (let i = 0; i < metaTags.length; i++) {
      if (metaTags[i].name === "description") {
        metaTags[i].content = "";
      }
    }
  };

  componentDidMount() {
    // check if this user can submit.

    this.setState({
      id: this.props.match.params.id,
    });
    // console.log("id", this.props.match.params.id)
    // const context = this.sigCanvas.getCanvas().getContext('2d');
    // get patient info for chosen patient
    axios
      .get(
        process.env.REACT_APP_DOMAIN +
          `/patients/${this.props.match.params.id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.token}`,
          },
        }
      )
      .then(({ data }) => {
        console.log("patient data", data);
        this.setState({
          patient: data,
        });
      });

    // get specific visit
    axios
      .get(
        process.env.REACT_APP_DOMAIN +
          `/visits/${this.props.match.params.visit}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.token}`,
          },
        }
      )
      .then(({ data }) => {
        console.log("visits", data);
        this.setState({
          visit: data,
          loading: false,
        });

        let notes = data.service[0].treatmentNotes;
        let submissionHistory = data.service[0].treatmentNotesSubmissionHistory
          ? data.service[0].treatmentNotesSubmissionHistory
          : [];
        let locked = data.service[0].locked ? data.service[0].locked : false;

        console.log("gotten visit", data.service[0], locked);
        this.checkIfCanSubmit(
          notes,
          submissionHistory.length,
          locked,
          data.date.end
        );
        if (notes) {
          this.setState({
            // treatment forms
            osteopathyTreatment: notes.osteopathyTreatment,
            massageTreatment: notes.massageTreatment,
            acupunctureTreatment: notes.acupunctureTreatment,
            naturopathicTreatment: notes.naturopathicTreatment,
            osteoAssessment: notes.osteoAssessment,
            acupunctureAssessment: notes.acupunctureAssessment,
            // osteo treatment
            rocking: notes.rocking,
            petrissage: notes.petrissage,
            friction: notes.friction,
            vibration: notes.vibration,
            MyofacialRelease: notes.MyofacialRelease,
            tender: notes.tender,
            muscleEnergy: notes.muscleEnergy,
            totalBody: notes.totalBody,
            stillTechnique: notes.stillTechnique,
            Craniosacral: notes.Craniosacral,
            Visceral: notes.Visceral,
            softTissue: notes.softTissue,
            stretch: notes.stretch,
            intraOral: notes.intraOral,
            techniqueOther: notes.techniqueOther,
            back: notes.back,
            neck: notes.neck,
            shoulders: notes.shoulders,
            face: notes.face,
            leftArm: notes.leftArm,
            rightArm: notes.rightArm,
            leftLeg: notes.leftLeg,
            rightLeg: notes.rightLeg,
            gluteus: notes.gluteus,
            abdominals: notes.abdominals,
            chest: notes.chest,
            breast: notes.breast,
            areasOther: notes.areasOther,
            osteoNotes: notes.osteoNotes,
            // massage treatment
            Swedish: notes.Swedish,
            frictions: notes.frictions,
            deepFacial: notes.deepFacial,
            triggerPoints: notes.triggerPoints,
            stretchMassage: notes.stretchMassage,
            intraOralMassage: notes.intraOralMassage,
            breastMassage: notes.breastMassage,
            hydrotherapy: notes.hydrotherapy,
            jointMobilization: notes.jointMobilization,
            grade: notes.grade,
            otherListMassage: notes.otherListMassage,
            backMassage: notes.backMassage,
            neckMassage: notes.neckMassage,
            shouldersMassage: notes.shouldersMassage,
            faceMassage: notes.faceMassage,
            leftArmMassage: notes.leftArmMassage,
            rightArmMassage: notes.rightArmMassage,
            leftLegMassage: notes.leftLegMassage,
            rightLegMassage: notes.rightLegMassage,
            hipArea: notes.hipArea,
            abdominalsMassage: notes.abdominalsMassage,
            chestMassage: notes.chestMassage,
            breastMassageMassage: notes.breastMassageMassage,
            areasOtherMassage: notes.areasOtherMassage,
            clinFinding: notes.clinFinding,
            cliReaction: notes.cliReaction,
            selfCare: notes.selfCare,
            // acu treatment
            progInqu: notes.progInqu,
            tongue: notes.tongue,
            Pulse: notes.Pulse,
            Palpation: notes.Palpation,
            General: notes.General,
            revisedDiag: notes.revisedDiag,
            duration: notes.duration,
            // acupuncture assessment
            currentIllness: notes.currentIllness,
            chiefComplaints: notes.chiefComplaints,
            medicalHistory: notes.medicalHistory,
            tongueAssessment: notes.tongueAssessment,
            PulseAssessment: notes.PulseAssessment,
            PalpationAssessment: notes.PalpationAssessment,
            tcmDiagnosis: notes.tcmDiagnosis,
            tcmTreatment: notes.tcmTreatment,
            treatmentPlan: notes.treatmentPlan,
            acupuncturePointsPrescription: notes.acupuncturePointsPrescription,
            adjunctModalities: notes.adjunctModalities,
            herbal: notes.herbal,
            // osteo assessment
            limitations: notes.limitations,
            treatmentDiscussed: notes.treatmentDiscussed,
            treatmentGoal: notes.treatmentGoal,
            receivedConsent: notes.receivedConsent,
            typeTreatment: notes.typeTreatment,
            frequencyAssessment: notes.frequencyAssessment,
            assessmentsPerformed: notes.assessmentsPerformed,
            anticipatedProgress: notes.anticipatedProgress,
            resultsOfAssessment: notes.resultsOfAssessment,
            remedialExercises: notes.remedialExercises,
            reassessment: notes.reassessment,
            risksAssessment: notes.risksAssessment,
            backAssessment: notes.backAssessment,
            neckAssessment: notes.neckAssessment,
            shouldersAssessment: notes.shouldersAssessment,
            faceAssessment: notes.faceAssessment,
            leftArmAssessment: notes.leftArmAssessment,
            rightArmAssessment: notes.rightArmAssessment,
            leftLegAssessment: notes.leftLegAssessment,
            rightLegAssessment: notes.rightLegAssessment,
            gluteusAssessment: notes.gluteusAssessment,
            abdominalsAssessment: notes.abdominalsAssessment,
            chestAssessment: notes.chestAssessment,
            breastAssessment: notes.breastAssessment,
            areasOtherAssessment: notes.areasOtherAssessment,
            naturopathicTreatment: notes.naturopathicTreatment,
            naturopathicSupplements: notes.naturopathicSupplements || [
              { supplement: "", dose: "", instructions: "" },
            ],
            naturopathicRecommendations: notes.naturopathicRecommendations,
            naturopathicSubjective: notes.naturopathicSubjective,
            naturopathicObjective: notes.naturopathicObjective,
            naturopathicAssessment: notes.naturopathicAssessment,
            naturopathicPlan: notes.naturopathicPlan,
            submissionHistory:
              data.service[0].treatmentNotesSubmissionHistory || null,
            locked: locked,
          });
        }
      });

    // const image = new Image();
    // image.src = PainRelief;
    // image.onload = () => {
    //     context.drawImage(image, 0, 0, 652, 446);
    // };
  }

  getPatientByID(patientID) {
    var promise = new Promise((resolve) => {
      var payload = patientID;
      this.getPatientReq(resolve, payload);
    });
    return promise;
  }

  getPatientReq(resolve, payload) {
    // console.log(payload)
    axios
      .get(process.env.REACT_APP_DOMAIN + "/patients/" + payload, {
        headers: {
          Authorization: `Bearer ${localStorage.token}`,
        },
      })
      .then((response) => {
        // console.log(response)
        // console.log("get request")
        if (response.data.successful === false) {
          // console.log("could not get patient")
          var errorMsg = response.data.reason;
          resolve(errorMsg);
        } else {
          resolve(response);
          // console.log(response);
          // console.log('got patient')
        }
      })
      .catch((error) => {
        // console.log(error)
        // console.log("get request error")
        var errorMsg = "Missing data";
        // Should send a response of 400 ***
        resolve(errorMsg);
      });
  }

  clear = () => {
    // console.log(
    //     "clear attempt"
    // )
    this.sigCanvas.clear();
    const context = this.sigCanvas.getCanvas().getContext("2d");

    const image = new Image();
    image.src = PainRelief;
    image.onload = () => {
      context.drawImage(image, 0, 0, 652, 446);
    };
  };

  clearAcu = () => {
    this.consentAcupunctureSig.clear();
  };
  clearOsteo = () => {
    this.consentOsteoSig.clear();
  };
  clearMassage = () => {
    this.consentMassageSig.clear();
  };

  handleCheckBoxChange = (event) => {
    this.setState({
      [event.target.name]: event.target.checked,
    });
  };

  handleInputChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleEmailChange(event) {
    this.setState({ email: event.target.value });
  }

  handleSubmit = (finalSubmission) => (event) => {
    this.intakeSubmit(finalSubmission).then((errorMsg) => {
      // console.log("submit hit");
      // Redirect and save username is no errors with sign up.
    });
  };

  generatePdf = () => {
    const treatmentData = {
      metadata: {
        duration: this.state.duration,
      },
      sections: [
        {
          id: "osteopathyTreatment",
          name: "Osteopathy Treatment",
          isSelected: this.state.osteopathyTreatment,
          questions: [
            {
              id: "techniquesUsed",
              name: "Techniques Used",
              type: "checkboxGroup",
              values: [
                {
                  id: "rocking",
                  label: "Rocking",
                  isChecked: this.state.rocking,
                },
                {
                  id: "petrissage",
                  label: "Petrissage",
                  isChecked: this.state.petrissage,
                },
                {
                  id: "friction",
                  label: "Friction",
                  isChecked: this.state.friction,
                },
                {
                  id: "vibration",
                  label: "Vibration",
                  isChecked: this.state.vibration,
                },
                {
                  id: "MyofacialRelease",
                  label: "Myofacial Release",
                  isChecked: this.state.MyofacialRelease,
                },
                {
                  id: "tender",
                  label: "Tender Point Release",
                  isChecked: this.state.tender,
                },
                {
                  id: "muscleEnergy",
                  label: "Muscle Energy",
                  isChecked: this.state.muscleEnergy,
                },
                {
                  id: "totalBody",
                  label: "Total Body Adjustment",
                  isChecked: this.state.totalBody,
                },
                {
                  id: "stillTechnique",
                  label: "Still Technique",
                  isChecked: this.state.stillTechnique,
                },
                {
                  id: "Craniosacral",
                  label: "Craniosacral",
                  isChecked: this.state.Craniosacral,
                },
                {
                  id: "Visceral",
                  label: "Visceral",
                  isChecked: this.state.Visceral,
                },
                {
                  id: "softTissue",
                  label: "Soft Tissue Joint Mobilization",
                  isChecked: this.state.softTissue,
                },
                {
                  id: "stretch",
                  label: "Stretch",
                  isChecked: this.state.stretch,
                },
                {
                  id: "intraOral",
                  label: "Intra-Oral",
                  isChecked: this.state.intraOral,
                },
              ],
            },
            {
              id: "techniqueOther",
              name: "Other Techniques",
              type: "text",
              value: this.state.techniqueOther,
            },
            {
              id: "areasTreated",
              name: "Areas Treated",
              type: "checkboxGroup",
              values: [
                { id: "back", label: "Back", isChecked: this.state.back },
                { id: "neck", label: "Neck", isChecked: this.state.neck },
                {
                  id: "shoulders",
                  label: "Shoulders",
                  isChecked: this.state.shoulders,
                },
                { id: "face", label: "Face", isChecked: this.state.face },
                {
                  id: "leftArm",
                  label: "Left Arm",
                  isChecked: this.state.leftArm,
                },
                {
                  id: "rightArm",
                  label: "Right Arm",
                  isChecked: this.state.rightArm,
                },
                {
                  id: "leftLeg",
                  label: "Left Leg",
                  isChecked: this.state.leftLeg,
                },
                {
                  id: "rightLeg",
                  label: "Right Leg",
                  isChecked: this.state.rightLeg,
                },
                {
                  id: "gluteus",
                  label: "Gluteus",
                  isChecked: this.state.gluteus,
                },
                {
                  id: "abdominals",
                  label: "Abdominals (Visceral)",
                  isChecked: this.state.abdominals,
                },
                { id: "chest", label: "Chest", isChecked: this.state.chest },
                { id: "breast", label: "Breast", isChecked: this.state.breast },
              ],
            },
            {
              id: "areasOther",
              name: "Other Areas",
              type: "text",
              value: this.state.areasOther,
            },
            {
              id: "osteoNotes",
              name: "Notes",
              type: "textArea",
              value: this.state.osteoNotes,
            },
          ],
        },
        {
          id: "massageTreatment",
          name: "Massage Treatment",
          isSelected: this.state.massageTreatment,
          questions: [
            {
              id: "techniquesUsed",
              name: "Techniques Used",
              type: "checkboxGroup",
              values: [
                {
                  id: "Swedish",
                  label: "Swedish",
                  isChecked: this.state.Swedish,
                },
                {
                  id: "frictions",
                  label: "Frictions",
                  isChecked: this.state.frictions,
                },
                {
                  id: "deepFacial",
                  label: "Deep Fascial Release",
                  isChecked: this.state.deepFacial,
                },
                {
                  id: "triggerPoints",
                  label: "Trigger Points",
                  isChecked: this.state.triggerPoints,
                },
                {
                  id: "stretchMassage",
                  label: "Stretch",
                  isChecked: this.state.stretchMassage,
                },
                {
                  id: "intraOralMassage",
                  label: "Intra-Oral",
                  isChecked: this.state.intraOralMassage,
                },
                {
                  id: "breastMassageMassage",
                  label: "Breast Massage",
                  isChecked: this.state.breastMassageMassage,
                },
                {
                  id: "hydrotherapy",
                  label: "Hydrotherapy",
                  isChecked: this.state.hydrotherapy,
                },
                {
                  id: "jointMobilization",
                  label: "Joint Mobilization",
                  isChecked: this.state.jointMobilization,
                },
              ],
            },
            {
              id: "grade",
              name: "Grade",
              type: "text",
              value: this.state.grade,
            },
            {
              id: "otherListMassage",
              name: "Other",
              type: "text",
              value: this.state.otherListMassage,
            },
            {
              id: "areasTreated",
              name: "Areas Treated",
              type: "checkboxGroup",
              values: [
                {
                  id: "backMassage",
                  label: "Back",
                  isChecked: this.state.backMassage,
                },
                {
                  id: "neckMassage",
                  label: "Neck",
                  isChecked: this.state.neckMassage,
                },
                {
                  id: "shouldersMassage",
                  label: "Shoulders",
                  isChecked: this.state.shouldersMassage,
                },
                {
                  id: "faceMassage",
                  label: "Face",
                  isChecked: this.state.faceMassage,
                },
                {
                  id: "leftArmMassage",
                  label: "Left Arm",
                  isChecked: this.state.leftArmMassage,
                },
                {
                  id: "rightArmMassage",
                  label: "Right Arm",
                  isChecked: this.state.rightArmMassage,
                },
                {
                  id: "leftLegMassage",
                  label: "Left Leg",
                  isChecked: this.state.leftLegMassage,
                },
                {
                  id: "rightLegMassage",
                  label: "Right Leg",
                  isChecked: this.state.rightLegMassage,
                },
                {
                  id: "hipArea",
                  label: "Hip Area",
                  isChecked: this.state.hipArea,
                },
                {
                  id: "abdominalsMassage",
                  label: "Abdominals",
                  isChecked: this.state.abdominalsMassage,
                },
                {
                  id: "chestMassage",
                  label: "Chest",
                  isChecked: this.state.chestMassage,
                },
                {
                  id: "breastMassage",
                  label: "Breast",
                  isChecked: this.state.breastMassage,
                },
              ],
            },
            {
              id: "areasOtherMassage",
              name: "Other Areas",
              type: "text",
              value: this.state.areasOtherMassage,
            },
            {
              id: "clinicalFindings",
              name: "Clinical Findings",
              type: "textArea",
              value: this.state.clinFinding,
            },
            {
              id: "clientReaction",
              name: "Client Reaction",
              type: "textArea",
              value: this.state.cliReaction,
            },
            {
              id: "selfCare",
              name: "Recommended Self Care",
              type: "textArea",
              value: this.state.selfCare,
            },
          ],
        },
        {
          id: "acupunctureTreatment",
          name: "Acupuncture/TCM Follow Up Treatment",
          isSelected: this.state.acupunctureTreatment,
          questions: [
            {
              id: "progressInquiry",
              name: "Progress Inquiry",
              type: "textArea",
              value: this.state.progInqu,
              description:
                "Treatment plan progress, patient's reactions, document Patient's referral to follow recommendation, contraindication, adjunct modalities/treatment or procedures used.",
            },
            {
              id: "examinations",
              name: "Examinations",
              type: "group",
              questions: [
                {
                  id: "tongue",
                  name: "Tongue",
                  type: "text",
                  value: this.state.tongue,
                },
                {
                  id: "pulse",
                  name: "Pulse",
                  type: "text",
                  value: this.state.Pulse,
                },
                {
                  id: "palpation",
                  name: "Palpation",
                  type: "text",
                  value: this.state.Palpation,
                },
                {
                  id: "general",
                  name: "General",
                  type: "text",
                  value: this.state.General,
                },
              ],
            },
            {
              id: "revisedDiagnosis",
              name: "Revised Diagnosis and Treatment",
              type: "textArea",
              value: this.state.revisedDiag,
              description:
                "1.Revised TCM Diagnosis/Differentiations; 2.Revised TCM Treatment Plan; 3.Revised Acupuncture Points Prescription; 4.Revised Herbal Prescription; 5. Adjunct Modalities",
            },
          ],
        },
        {
          id: "naturopathicTreatment",
          name: "Naturopathic Treatment",
          isSelected: this.state.naturopathicTreatment,
          questions: [
            {
              id: "subjective",
              name: "Subjective",
              type: "textArea",
              value: this.state.naturopathicSubjective,
              description: "Patient reported symptoms/concerns",
            },
            {
              id: "objective",
              name: "Objective",
              type: "textArea",
              value: this.state.naturopathicObjective,
              description: "Observable findings/test results",
            },
            {
              id: "assessment",
              name: "Assessment",
              type: "textArea",
              value: this.state.naturopathicAssessment,
              description: "Clinical evaluation and diagnosis",
            },
            {
              id: "plan",
              name: "Plan",
              type: "textArea",
              value: this.state.naturopathicPlan,
              description: "Treatment approach and recommendations",
            },
            {
              id: "supplements",
              name: "Supplements",
              type: "table",
              columns: ["Supplement", "Dose", "Additional Instructions"],
              value: this.state.naturopathicSupplements,
            },
          ],
        },
        {
          id: "acupunctureAssessment",
          name: "Initial Acupuncture/TCM Assessment and Treatment Record",
          isSelected: this.state.acupunctureAssessment,
          questions: [
            {
              id: "chiefComplaintsSection",
              name: "Assessment",
              type: "group",
              questions: [
                {
                  id: "chiefComplaints",
                  name: "Chief Complaints and Duration",
                  type: "textArea",
                  value: this.state.chiefComplaints,
                  description: "",
                },
                {
                  id: "currentIllness",
                  name: "Current Illness/Symptoms",
                  type: "textArea",
                  value: this.state.currentIllness,
                  description:
                    "Energy, Sleep, Appetite, Diet, Thirsty, Body Temperature, Sweating, Body Pains, Bowels, Urine, Menstruations",
                },
                {
                  id: "medicalHistory",
                  name: "Medical History",
                  type: "textArea",
                  value: this.state.medicalHistory,
                  description:
                    "Previous family health, ongoing problems, past illness/operations, prescription drugs, allergies, nutrition supplement, other health care provider's referral and/or treatments",
                },
              ],
            },
            {
              id: "examinations",
              name: "Examinations",
              type: "group",
              questions: [
                {
                  id: "tongueAssessment",
                  name: "Tongue",
                  type: "text",
                  value: this.state.tongueAssessment,
                },
                {
                  id: "PulseAssessment",
                  name: "Pulse",
                  type: "text",
                  value: this.state.PulseAssessment,
                },
                {
                  id: "PalpationAssessment",
                  name: "Palpation",
                  type: "text",
                  value: this.state.PalpationAssessment,
                },
              ],
            },
            {
              id: "diagnosisAndTreatment",
              name: "Diagnosis and Treatment",
              type: "group",
              questions: [
                {
                  id: "tcmDiagnosis",
                  name: "TCM Diagnosis and Differentiations",
                  type: "textArea",
                  value: this.state.tcmDiagnosis,
                },
                {
                  id: "tcmTreatment",
                  name: "TCM Treatment Principals",
                  type: "textArea",
                  value: this.state.tcmTreatment,
                },
                {
                  id: "treatmentPlan",
                  name: "Treatment Plan/Advice",
                  type: "textArea",
                  value: this.state.treatmentPlan,
                  description: "",
                },
                {
                  id: "acupuncturePointsPrescription",
                  name: "Acupuncture Points Prescription, Technique, Retention",
                  type: "textArea",
                  value: this.state.acupuncturePointsPrescription,
                  description: "",
                },
                {
                  id: "herbal",
                  name: "Herbal Prescription",
                  type: "textArea",
                  value: this.state.herbal,
                  description:
                    "Formula Name & Dosage; Type: Ingredients of Granule herbs & Dosage & Frequency; Instructions for preparation and consumption",
                },
                {
                  id: "adjunctModalities",
                  name: "Adjunct Modalities: Cupping, Exercise, Dietary therapy, Tui Na Therapy, others",
                  type: "textArea",
                  value: this.state.adjunctModalities,
                  description: "",
                },
              ],
            },
          ],
        },
        {
          id: "osteoAssessment",
          name: "Osteopathy and Massage Assessment",
          isSelected: this.state.osteoAssessment,
          questions: [
            {
              id: "limitations",
              name: "Limitations of activities of daily living",
              type: "textArea",
              value: this.state.limitations,
            },
            {
              id: "consentAndPlan",
              name: "Treatment Plan & Consent",
              type: "checkboxGroup",
              values: [
                {
                  id: "treatmentDiscussed",
                  label: "Treatment plan discussed with Client",
                  isChecked: this.state.treatmentDiscussed,
                },
                {
                  id: "receivedConsent",
                  label: "Received informed consent for treatment plan",
                  isChecked: this.state.receivedConsent,
                },
              ],
            },
            {
              id: "treatmentGoal",
              name: "Clients Goal / Treatment Goal",
              type: "textArea",
              value: this.state.treatmentGoal,
            },
            {
              id: "typeTreatment",
              name: "Type / Focus of treatment",
              type: "textArea",
              value: this.state.typeTreatment,
            },
            {
              id: "frequencyAssessment",
              name: "Frequency and Duration",
              type: "textArea",
              value: this.state.frequencyAssessment,
            },
            {
              id: "assessmentsPerformed",
              name: "Assessments Performed",
              type: "textArea",
              value: this.state.assessmentsPerformed,
            },
            {
              id: "anticipatedProgress",
              name: "Anticipated Progression of Responses",
              type: "textArea",
              value: this.state.anticipatedProgress,
            },
            {
              id: "resultsOfAssessment",
              name: "Results of Assessments",
              type: "textArea",
              value: this.state.resultsOfAssessment,
            },
            {
              id: "remedialExercises",
              name: "Remedial exercises/ Hydrotherapy recommended",
              type: "textArea",
              value: this.state.remedialExercises,
            },
            {
              id: "reassessment",
              name: "Reassessment schedule",
              type: "textArea",
              value: this.state.reassessment,
            },
            {
              id: "risksAssessment",
              name: "Contraindications / Risks",
              type: "textArea",
              value: this.state.risksAssessment,
            },
            {
              id: "areasTreatedAssessment",
              name: "Areas Treated",
              type: "checkboxGroup",
              values: [
                {
                  id: "backAssessment",
                  label: "Back",
                  isChecked: this.state.backAssessment,
                },
                {
                  id: "neckAssessment",
                  label: "Neck",
                  isChecked: this.state.neckAssessment,
                },
                {
                  id: "shouldersAssessment",
                  label: "Shoulders",
                  isChecked: this.state.shouldersAssessment,
                },
                {
                  id: "faceAssessment",
                  label: "Face",
                  isChecked: this.state.faceAssessment,
                },
                {
                  id: "leftArmAssessment",
                  label: "Left Arm",
                  isChecked: this.state.leftArmAssessment,
                },
                {
                  id: "rightArmAssessment",
                  label: "Right Arm",
                  isChecked: this.state.rightArmAssessment,
                },
                {
                  id: "leftLegAssessment",
                  label: "Left Leg",
                  isChecked: this.state.leftLegAssessment,
                },
                {
                  id: "rightLegAssessment",
                  label: "Right Leg",
                  isChecked: this.state.rightLegAssessment,
                },
                {
                  id: "gluteusAssessment",
                  label: "Gluteus",
                  isChecked: this.state.gluteusAssessment,
                },
                {
                  id: "abdominalsAssessment",
                  label: "Abdominals (visceral)",
                  isChecked: this.state.abdominalsAssessment,
                },
                {
                  id: "chestAssessment",
                  label: "Chest",
                  isChecked: this.state.chestAssessment,
                },
                {
                  id: "breastAssessment",
                  label: "Breast",
                  isChecked: this.state.breastAssessment,
                },
              ],
            },
            {
              id: "areasOtherAssessment",
              name: "Other Areas",
              type: "text",
              value: this.state.areasOtherAssessment,
            },
          ],
        },
      ],
    };

    // Do not include address in PDF generation.
    // let address = {
    //   addressStreet: this.state.patient.intake.general.addressStreet,
    //   addressCity: this.state.patient.intake.general.addressCity,
    //   addressPostal: this.state.patient.intake.general.addressPostal,
    // };

    // console.log("Generating PDF with data:", address);

    generatePdf(
      treatmentData,
      this.state.visit
      // address.addressStreet ? address : null
    );
  };
  checkIfCanSubmit(notes, submissionHistoryLength, locked, date) {
    // Default to not being able to submit
    let canSubmit = false;

    if (this.props.admin) {
      if (this.props.admin.permissions === "Administrator") {
        // Administrators can always submit
        canSubmit = true;
      } else if (this.props.admin.permissions === "User" && !locked) {
        // Check if date is less than 30 days old
        const visitDate = new Date(date);
        const currentDate = new Date();
        const daysDifference = Math.floor(
          (currentDate - visitDate) / (1000 * 60 * 60 * 24)
        );
        const isRecent = daysDifference <= 30;

        // Regular users can submit if:
        // 1. There are no existing notes
        // 2. OR there are fewer than 6 submissions in history
        // 3. OR the notes are not locked
        // 4. AND the date is less than 30 days old

        canSubmit =
          isRecent &&
          (!notes ||
            (submissionHistoryLength < 5 && submissionHistoryLength > 0));

        console.log(
          "is recent",
          isRecent,
          visitDate,
          currentDate,
          daysDifference
        );
      }

      this.setState({ canSubmit });

      console.log(
        "User can submit - permissions allow",
        this.props.admin.permissions,
        !!notes,
        submissionHistoryLength,
        locked,
        canSubmit
      );

      if (canSubmit) {
      } else {
        console.log("User cannot submit - submission limit reached");
      }
    }
  }

  intakeSubmit(finalSubmission) {
    var promise = new Promise((resolve) => {
      var payload = {
        id: this.props.match.params.visit,
        submitter: this.props.admin ? this.props.admin.name : "unknown",
        locked: finalSubmission,
        treatmentNotes: {
          osteopathyTreatment: this.state.osteopathyTreatment,
          massageTreatment: this.state.massageTreatment,
          acupunctureTreatment: this.state.acupunctureTreatment,
          naturopathicTreatment: this.state.naturopathicTreatment,
          osteoAssessment: this.state.osteoAssessment,
          acupunctureAssessment: this.state.acupunctureAssessment,
          // osteo treatment
          rocking: this.state.rocking,
          petrissage: this.state.petrissage,
          friction: this.state.friction,
          vibration: this.state.vibration,
          MyofacialRelease: this.state.MyofacialRelease,
          tender: this.state.tender,
          muscleEnergy: this.state.muscleEnergy,
          totalBody: this.state.totalBody,
          stillTechnique: this.state.stillTechnique,
          Craniosacral: this.state.Craniosacral,
          Visceral: this.state.Visceral,
          softTissue: this.state.softTissue,
          stretch: this.state.stretch,
          intraOral: this.state.intraOral,
          techniqueOther: this.state.techniqueOther,
          back: this.state.back,
          neck: this.state.neck,
          shoulders: this.state.shoulders,
          face: this.state.face,
          leftArm: this.state.leftArm,
          rightArm: this.state.rightArm,
          leftLeg: this.state.leftLeg,
          rightLeg: this.state.rightLeg,
          gluteus: this.state.gluteus,
          abdominals: this.state.abdominals,
          chest: this.state.chest,
          breast: this.state.breast,
          areasOther: this.state.areasOther,
          osteoNotes: this.state.osteoNotes,
          // massage treatment
          Swedish: this.state.Swedish,
          frictions: this.state.frictions,
          deepFacial: this.state.deepFacial,
          triggerPoints: this.state.triggerPoints,
          stretchMassage: this.state.stretchMassage,
          intraOralMassage: this.state.intraOralMassage,
          breastMassage: this.state.breastMassage,
          hydrotherapy: this.state.hydrotherapy,
          jointMobilization: this.state.jointMobilization,
          grade: this.state.grade,
          otherListMassage: this.state.otherListMassage,
          backMassage: this.state.backMassage,
          neckMassage: this.state.neckMassage,
          shouldersMassage: this.state.shouldersMassage,
          faceMassage: this.state.faceMassage,
          leftArmMassage: this.state.leftArmMassage,
          rightArmMassage: this.state.rightArmMassage,
          leftLegMassage: this.state.leftLegMassage,
          rightLegMassage: this.state.rightLegMassage,
          hipArea: this.state.hipArea,
          abdominalsMassage: this.state.abdominalsMassage,
          chestMassage: this.state.chestMassage,
          breastMassageMassage: this.state.breastMassageMassage,
          areasOtherMassage: this.state.areasOtherMassage,
          clinFinding: this.state.clinFinding,
          cliReaction: this.state.cliReaction,
          selfCare: this.state.selfCare,
          // acu treatment
          progInqu: this.state.progInqu,
          tongue: this.state.tongue,
          Pulse: this.state.Pulse,
          Palpation: this.state.Palpation,
          General: this.state.General,
          revisedDiag: this.state.revisedDiag,
          duration: this.state.duration,
          // acupuncture assessment
          currentIllness: this.state.currentIllness,
          chiefComplaints: this.state.chiefComplaints,
          medicalHistory: this.state.medicalHistory,
          tongueAssessment: this.state.tongueAssessment,
          PulseAssessment: this.state.PulseAssessment,
          PalpationAssessment: this.state.PalpationAssessment,
          tcmDiagnosis: this.state.tcmDiagnosis,
          tcmTreatment: this.state.tcmTreatment,
          treatmentPlan: this.state.treatmentPlan,
          acupuncturePointsPrescription:
            this.state.acupuncturePointsPrescription,
          adjunctModalities: this.state.adjunctModalities,
          herbal: this.state.herbal,
          // osteo assessment
          limitations: this.state.limitations,
          treatmentDiscussed: this.state.treatmentDiscussed,
          treatmentGoal: this.state.treatmentGoal,
          receivedConsent: this.state.receivedConsent,
          typeTreatment: this.state.typeTreatment,
          frequencyAssessment: this.state.frequencyAssessment,
          assessmentsPerformed: this.state.assessmentsPerformed,
          anticipatedProgress: this.state.anticipatedProgress,
          resultsOfAssessment: this.state.resultsOfAssessment,
          remedialExercises: this.state.remedialExercises,
          reassessment: this.state.reassessment,
          risksAssessment: this.state.risksAssessment,
          backAssessment: this.state.backAssessment,
          neckAssessment: this.state.neckAssessment,
          shouldersAssessment: this.state.shouldersAssessment,
          faceAssessment: this.state.faceAssessment,
          leftArmAssessment: this.state.leftArmAssessment,
          rightArmAssessment: this.state.rightArmAssessment,
          leftLegAssessment: this.state.leftLegAssessment,
          rightLegAssessment: this.state.rightLegAssessment,
          gluteusAssessment: this.state.gluteusAssessment,
          abdominalsAssessment: this.state.abdominalsAssessment,
          chestAssessment: this.state.chestAssessment,
          breastAssessment: this.state.breastAssessment,
          areasOtherAssessment: this.state.areasOtherAssessment,
          // naturopathic treatment
          naturopathicTreatment: this.state.naturopathicTreatment,
          naturopathicSupplements: this.state.naturopathicSupplements,
          naturopathicRecommendations: this.state.naturopathicRecommendations,
          naturopathicSubjective: this.state.naturopathicSubjective,
          naturopathicObjective: this.state.naturopathicObjective,
          naturopathicAssessment: this.state.naturopathicAssessment,
          naturopathicPlan: this.state.naturopathicPlan,
        },
      };

      // console.log("payload", payload)
      this.intakeSubmitReq(resolve, payload);
    });
    return promise;
  }

  intakeSubmitReq(resolve, payload) {
    axios
      .post(url + "/visits/treatmentnotes", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.token}`,
        },
      })
      .then((response) => {
        // console.log(response)
        // console.log("post request")
        if (response.data.successful === false) {
          // console.log("intake failed")
          var errorMsg = response.data.reason;
          resolve(errorMsg);
        } else {
          resolve("");
          // console.log(response);
          // this.props.fetchVisits()
          this.props.fetchVisits(
            moment().subtract(7, "days").format("YYYY-MM-DD"),
            moment().add(7, "days").format("YYYY-MM-DD")
          );

          // console.log('intake succeeded!')
          this.props.history.push("/patient/" + this.props.match.params.id);
        }
      })
      .catch((error) => {
        // console.log(error)
        // console.log("post request error")
        var errorMsg = "Missing data";
        // Should send a response of 400 ***
        resolve(errorMsg);
      });
  }

  handleSupplementChange = (index, field, value) => {
    const updatedSupplements = [...this.state.naturopathicSupplements];
    updatedSupplements[index][field] = value;
    this.setState({ naturopathicSupplements: updatedSupplements });
  };

  addSupplementRow = () => {
    this.setState({
      naturopathicSupplements: [
        ...this.state.naturopathicSupplements,
        { supplement: "", dose: "", instructions: "" },
      ],
    });
  };

  removeSupplementRow = () => {
    if (this.state.naturopathicSupplements.length > 1) {
      const updatedSupplements = [...this.state.naturopathicSupplements];
      updatedSupplements.pop();
      this.setState({ naturopathicSupplements: updatedSupplements });
    }
  };

  render() {
    return (
      <div>
        {this.state.loading ? (
          <div>
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                width: 500,
                height: 200,
                marginTop: -100,
                marginLeft: -250,
                textAlign: "center",
              }}
            >
              <Typography component="h1" style={{ fontSize: 25 }}>
                Welcome to Appleby Wellness
              </Typography>
              <Typography component="p" style={{ fontWeight: "lighter" }}>
                Loading in your information.
              </Typography>
              <CircularProgress style={{ margin: "3rem" }} />
            </div>
          </div>
        ) : (
          <ThemeProvider theme={theme}>
            <Grid
              container
              direction="row"
              justify="left"
              alignItems="left"
              style={{ marginTop: 0, padding: 70 }}
            >
              <Grid item xs={12} sm={12}>
                <div
                  style={{
                    marginBottom: 30,
                    borderBottom: "1px solid #e0e0e0",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <div>
                      <Typography variant="h4" style={{ marginBottom: 15 }}>
                        Treatment Notes
                      </Typography>
                      <Typography variant="h6" style={{ marginBottom: 10 }}>
                        {this.state.visit.patient.name}
                      </Typography>
                      {/* {this.state.patient.intake && (
                        <Typography
                          variant="body2"
                          style={{ marginBottom: 10 }}
                        >
                          {this.state.patient.intake.general.addressStreet
                            ? this.state.patient.intake.general.addressStreet
                            : "Address not provided"}{" "}
                          <br />
                          {this.state.patient.intake.general.addressCity
                            ? this.state.patient.intake.general.addressCity
                            : ""}
                          <br />
                          {this.state.patient.intake.general.addressPostal
                            ? this.state.patient.intake.general.addressPostal
                            : ""}{" "}
                          <br />
                        </Typography>
                      )} */}

                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          marginTop: 15,
                        }}
                      >
                        <div style={{ marginRight: 40, marginBottom: 10 }}>
                          <Typography variant="caption" color="textSecondary">
                            DATE
                          </Typography>
                          <Typography variant="body1">
                            {String(
                              months[
                                new Date(this.state.visit.date.start).getMonth()
                              ]
                            )}{" "}
                            {String(
                              new Date(this.state.visit.date.start).getDate()
                            )}
                            ,{" "}
                            {String(
                              new Date(
                                this.state.visit.date.start
                              ).getFullYear()
                            )}
                          </Typography>
                        </div>

                        <div style={{ marginRight: 40, marginBottom: 10 }}>
                          <Typography variant="caption" color="textSecondary">
                            TIME
                          </Typography>
                          <Typography variant="body1">
                            {new Date(
                              this.state.visit.date.start
                            ).toLocaleTimeString("en-US", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })}{" "}
                            -{" "}
                            {new Date(
                              this.state.visit.date.end
                            ).toLocaleTimeString("en-US", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })}
                          </Typography>
                        </div>

                        <div style={{ marginRight: 40, marginBottom: 10 }}>
                          <Typography variant="caption" color="textSecondary">
                            PRACTITIONER
                          </Typography>
                          <Typography variant="body1">
                            {this.state.visit.service[0].practitioner.name}
                          </Typography>
                        </div>

                        <div style={{ marginBottom: 10 }}>
                          <Typography variant="caption" color="textSecondary">
                            PRIMARY SERVICE
                          </Typography>
                          <Typography variant="body1">
                            {this.state.visit.service[0].type}
                          </Typography>
                        </div>
                      </div>
                    </div>

                    <img
                      src={Logo}
                      alt="Appleby Wellness"
                      style={{
                        height: 80,
                        marginLeft: 20,
                        objectFit: "contain",
                      }}
                    />
                  </div>
                </div>
                <br />
                <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                  Treatment/Assessment Duration (Mins)
                </Typography>
                <br />
                <TextField
                  ref="other"
                  label="Time"
                  id="margin-none"
                  className="other"
                  onChange={this.handleInputChange}
                  style={{ width: "100%" }}
                  variant={"outlined"}
                  name="duration"
                  value={this.state.duration}
                />
                <br /> <br /> <br />
                <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                  Which of the following forms will you be filling out?
                </Typography>
                <br />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.osteopathyTreatment}
                      onChange={this.handleCheckBoxChange}
                      color="primary"
                      name="osteopathyTreatment"
                      value={this.state.osteopathyTreatment}
                    />
                  }
                  label="Osteopathy Treatment"
                />
                <br />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.massageTreatment}
                      onChange={this.handleCheckBoxChange}
                      color="primary"
                      name="massageTreatment"
                      value={this.state.massageTreatment}
                    />
                  }
                  label="Massage Treatment"
                />
                <br />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.acupunctureTreatment}
                      onChange={this.handleCheckBoxChange}
                      color="primary"
                      name="acupunctureTreatment"
                      value={this.state.acupunctureTreatment}
                    />
                  }
                  label="Acupuncture/TCM Follow Up Treatment Record"
                />
                <br />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.naturopathicTreatment}
                      onChange={this.handleCheckBoxChange}
                      color="primary"
                      name="naturopathicTreatment"
                      value={this.state.naturopathicTreatment}
                    />
                  }
                  label="Naturopathic Treatment"
                />
                <br />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.osteoAssessment}
                      onChange={this.handleCheckBoxChange}
                      color="primary"
                      name="osteoAssessment"
                      value={this.state.osteoAssessment}
                    />
                  }
                  label="Osteopathy and Massage Assessment"
                />
                <br />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.acupunctureAssessment}
                      onChange={this.handleCheckBoxChange}
                      color="primary"
                      name="acupunctureAssessment"
                      value={this.state.acupunctureAssessment}
                    />
                  }
                  label="Initial Acupuncture/TCM Assessment and Treatment Record"
                />
                <br />
                {this.state.osteopathyTreatment && (
                  <>
                    <hr style={{ opacity: "20%" }} />
                    <Typography
                      variant="h5"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Osteopathy Treatment
                    </Typography>
                    <br />
                    <Typography
                      variant="overline"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Techniques Used
                    </Typography>
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.rocking}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="rocking"
                          value={this.state.rocking}
                        />
                      }
                      label="Rocking"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.petrissage}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="petrissage"
                          value={this.state.petrissage}
                        />
                      }
                      label="Petrissage"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.friction}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="friction"
                          value={this.state.friction}
                        />
                      }
                      label="Friction"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.vibration}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="vibration"
                          value={this.state.vibration}
                        />
                      }
                      label="Vibration"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.MyofacialRelease}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="MyofacialRelease"
                          value={this.state.MyofacialRelease}
                        />
                      }
                      label="Myofacial release"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.tender}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="tender"
                          value={this.state.tender}
                        />
                      }
                      label="Tender Point release"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.muscleEnergy}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="muscleEnergy"
                          value={this.state.muscleEnergy}
                        />
                      }
                      label="Muscle Energy"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.totalBody}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="totalBody"
                          value={this.state.totalBody}
                        />
                      }
                      label="Total Body Adjustment"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.stillTechnique}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="stillTechnique"
                          value={this.state.stillTechnique}
                        />
                      }
                      label="Still Technique"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.Craniosacral}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="Craniosacral"
                          value={this.state.Craniosacral}
                        />
                      }
                      label="Craniosacral"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.Visceral}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="Visceral"
                          value={this.state.Visceral}
                        />
                      }
                      label="Visceral"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.softTissue}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="softTissue"
                          value={this.state.softTissue}
                        />
                      }
                      label="Soft Tissue joint
                                        mobilization
                                        "
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.stretch}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="stretch"
                          value={this.state.stretch}
                        />
                      }
                      label="stretch"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.intraOral}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="intraOral"
                          value={this.state.intraOral}
                        />
                      }
                      label="intra-oral"
                    />
                    <br />

                    <TextField
                      ref="other"
                      label="Other"
                      id="margin-none"
                      className="other"
                      onChange={this.handleInputChange}
                      style={{ width: "100%" }}
                      variant={"outlined"}
                      name="techniqueOther"
                      value={this.state.techniqueOther}
                    />
                    <br />
                    <br />
                    <Typography
                      variant="overline"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Areas Treated
                    </Typography>
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.back}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="back"
                          value={this.state.back}
                        />
                      }
                      label="back"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.neck}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="neck"
                          value={this.state.neck}
                        />
                      }
                      label="neck"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.shoulders}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="shoulders"
                          value={this.state.shoulders}
                        />
                      }
                      label="shoulders"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.face}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="face"
                          value={this.state.face}
                        />
                      }
                      label="face"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.leftArm}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="leftArm"
                          value={this.state.leftArm}
                        />
                      }
                      label="Left Arm"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.rightArm}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="rightArm"
                          value={this.state.rightArm}
                        />
                      }
                      label="Right Arm"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.leftLeg}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="leftLeg"
                          value={this.state.leftLeg}
                        />
                      }
                      label="Left Leg"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.rightLeg}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="rightLeg"
                          value={this.state.rightLeg}
                        />
                      }
                      label="Right Leg"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.gluteus}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="gluteus"
                          value={this.state.gluteus}
                        />
                      }
                      label="gluteus"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.abdominals}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="abdominals"
                          value={this.state.abdominals}
                        />
                      }
                      label="abdominals (visceral)"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.chest}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="chest"
                          value={this.state.chest}
                        />
                      }
                      label="chest"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.breast}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="breast"
                          value={this.state.breast}
                        />
                      }
                      label="breast"
                    />
                    <br />

                    <TextField
                      ref="areasOther"
                      label="Other"
                      id="margin-none"
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ width: "100%" }}
                      variant={"outlined"}
                      name="areasOther"
                      value={this.state.areasOther}
                    />
                    <TextField
                      id="outlined-multiline-static"
                      onChange={this.handleInputChange}
                      label="Notes"
                      multiline
                      rows={3}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant="outlined"
                      name="osteoNotes"
                      value={this.state.osteoNotes}
                    />
                  </>
                )}
                {/* <SignatureCanvas penColor='black' ref={(ref) => { this.sigCanvas = ref }}
                                canvasProps={{ width: 652, height: 446, className: 'sigCanvas' }} /> */}
                <br />
                {this.state.massageTreatment && (
                  <>
                    <hr style={{ opacity: "20%" }} />
                    <Typography
                      variant="h5"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Massage Treatment
                    </Typography>
                    <br />
                    <Typography
                      variant="overline"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Techniques Used
                    </Typography>
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.Swedish}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="Swedish"
                          value={this.state.Swedish}
                        />
                      }
                      label="Swedish"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.frictions}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="frictions"
                          value={this.state.frictions}
                        />
                      }
                      label="frictions"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.deepFacial}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="deepFacial"
                          value={this.state.deepFacial}
                        />
                      }
                      label="deep facial"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.triggerPoints}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="triggerPoints"
                          value={this.state.triggerPoints}
                        />
                      }
                      label="trigger points"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.stretchMassage}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="stretchMassage"
                          value={this.state.stretchMassage}
                        />
                      }
                      label="stretch"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.intraOralMassage}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="intraOralMassage"
                          value={this.state.intraOralMassage}
                        />
                      }
                      label="intra-oral"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.breastMassageMassage}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="breastMassageMassage"
                          value={this.state.breastMassageMassage}
                        />
                      }
                      label="breast massage"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.hydrotherapy}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="hydrotherapy"
                          value={this.state.hydrotherapy}
                        />
                      }
                      label="hydrotherapy"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.jointMobilization}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="jointMobilization"
                          value={this.state.jointMobilization}
                        />
                      }
                      label="joint mobilization "
                    />

                    <br />

                    <TextField
                      ref="other"
                      label="Grade"
                      id="margin-none"
                      className="other"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="grade"
                      value={this.state.grade}
                    />
                    <br />
                    <TextField
                      ref="other"
                      label="Other"
                      id="margin-none"
                      className="other"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="otherListMassage"
                      value={this.state.otherListMassage}
                    />
                    <br />
                    <br />
                    <Typography
                      variant="overline"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Areas Treated
                    </Typography>
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.backMassage}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="backMassage"
                          value={this.state.backMassage}
                        />
                      }
                      label="back"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.neckMassage}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="neckMassage"
                          value={this.state.neckMassage}
                        />
                      }
                      label="neck"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.shouldersMassage}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="shouldersMassage"
                          value={this.state.shouldersMassage}
                        />
                      }
                      label="shoulders"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.faceMassage}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="faceMassage"
                          value={this.state.faceMassage}
                        />
                      }
                      label="face"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.leftArmMassage}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="leftArmMassage"
                          value={this.state.leftArmMassage}
                        />
                      }
                      label="Left Arm"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.rightArmMassage}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="rightArmMassage"
                          value={this.state.rightArmMassage}
                        />
                      }
                      label="Right Arm"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.leftLegMassage}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="leftLegMassage"
                          value={this.state.leftLegMassage}
                        />
                      }
                      label="Left Leg"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.rightLegMassage}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="rightLegMassage"
                          value={this.state.rightLegMassage}
                        />
                      }
                      label="Right Leg"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.hipArea}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="hipArea"
                          value={this.state.hipArea}
                        />
                      }
                      label="hip area"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.abdominalsMassage}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="abdominalsMassage"
                          value={this.state.abdominalsMassage}
                        />
                      }
                      label="abdominals"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.chestMassage}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="chestMassage"
                          value={this.state.chestMassage}
                        />
                      }
                      label="chest"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.breastMassage}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="breastMassage"
                          value={this.state.breastMassage}
                        />
                      }
                      label="breast"
                    />
                    <br />
                    <TextField
                      ref="areasOther"
                      label="Other"
                      id="margin-none"
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="areasOtherMassage"
                      value={this.state.areasOtherMassage}
                    />
                    <TextField
                      id="outlined-multiline-static"
                      onChange={this.handleInputChange}
                      label="Clinical Findings"
                      multiline
                      rows={3}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant="outlined"
                      name="clinFinding"
                      value={this.state.clinFinding}
                    />
                    <TextField
                      id="outlined-multiline-static"
                      onChange={this.handleInputChange}
                      label="Client Reaction"
                      multiline
                      rows={3}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant="outlined"
                      name="cliReaction"
                      value={this.state.cliReaction}
                    />
                    <TextField
                      id="outlined-multiline-static"
                      onChange={this.handleInputChange}
                      label="Recommended Self Care"
                      multiline
                      rows={3}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant="outlined"
                      name="selfCare"
                      value={this.state.selfCare}
                    />
                  </>
                )}
                <br />
                {this.state.naturopathicTreatment && (
                  <>
                    <hr style={{ opacity: "20%" }} />
                    <Typography
                      variant="h5"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Naturopathic Treatment
                    </Typography>
                    <br />
                    <Typography
                      variant="overline"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Subjective
                    </Typography>
                    <br />
                    <TextField
                      id="naturopathic-subjective"
                      onChange={this.handleInputChange}
                      label="Patient reported symptoms/concerns"
                      multiline
                      rows={4}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant="outlined"
                      name="naturopathicSubjective"
                      value={this.state.naturopathicSubjective}
                    />

                    <Typography
                      variant="overline"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Objective
                    </Typography>
                    <br />
                    <TextField
                      id="naturopathic-objective"
                      onChange={this.handleInputChange}
                      label="Observable findings/test results"
                      multiline
                      rows={4}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant="outlined"
                      name="naturopathicObjective"
                      value={this.state.naturopathicObjective}
                    />

                    <Typography
                      variant="overline"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Assessment
                    </Typography>
                    <br />
                    <TextField
                      id="naturopathic-assessment"
                      onChange={this.handleInputChange}
                      label="Clinical evaluation and diagnosis"
                      multiline
                      rows={4}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant="outlined"
                      name="naturopathicAssessment"
                      value={this.state.naturopathicAssessment}
                    />

                    <Typography
                      variant="overline"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Plan
                    </Typography>
                    <br />
                    <TextField
                      id="naturopathic-plan"
                      onChange={this.handleInputChange}
                      label="Treatment approach and recommendations"
                      multiline
                      rows={4}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant="outlined"
                      name="naturopathicPlan"
                      value={this.state.naturopathicPlan}
                    />

                    <Typography
                      variant="overline"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Supplements
                    </Typography>
                    <br />
                    <div style={{ marginBottom: 20 }}>
                      <div style={{ display: "flex", marginBottom: 10 }}>
                        <Typography style={{ flex: 1, fontWeight: "bold" }}>
                          Supplement
                        </Typography>
                        <Typography style={{ flex: 1, fontWeight: "bold" }}>
                          Dose
                        </Typography>
                        <Typography style={{ flex: 1.5, fontWeight: "bold" }}>
                          Additional Instructions
                        </Typography>
                      </div>
                      {this.state.naturopathicSupplements.map((row, index) => (
                        <div
                          key={index}
                          style={{ display: "flex", marginBottom: 10 }}
                        >
                          <TextField
                            style={{ flex: 1, marginRight: 8 }}
                            variant="outlined"
                            value={row.supplement}
                            onChange={(e) =>
                              this.handleSupplementChange(
                                index,
                                "supplement",
                                e.target.value
                              )
                            }
                          />
                          <TextField
                            style={{ flex: 1, marginRight: 8 }}
                            variant="outlined"
                            value={row.dose}
                            onChange={(e) =>
                              this.handleSupplementChange(
                                index,
                                "dose",
                                e.target.value
                              )
                            }
                          />
                          <TextField
                            style={{ flex: 1.5 }}
                            variant="outlined"
                            value={row.instructions}
                            onChange={(e) =>
                              this.handleSupplementChange(
                                index,
                                "instructions",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      ))}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginTop: 10,
                        }}
                      >
                        <Button
                          variant="outlined"
                          color="primary"
                          style={{ marginRight: 10 }}
                          onClick={this.addSupplementRow}
                        >
                          + Add Row
                        </Button>
                        <Button
                          variant="outlined"
                          color="secondary"
                          onClick={this.removeSupplementRow}
                        >
                          - Remove Row
                        </Button>
                      </div>
                    </div>
                    <br />
                    {/* <Typography
                      variant="overline"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Additional Recommendations
                    </Typography>
                    <br />
                    <TextField
                      id="outlined-multiline-static"
                      onChange={this.handleInputChange}
                      label="Recommendations"
                      multiline
                      rows={4}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant="outlined"
                      name="naturopathicRecommendations"
                      value={this.state.naturopathicRecommendations}
                    /> */}
                  </>
                )}
                {this.state.acupunctureTreatment && (
                  <>
                    <hr style={{ opacity: "20%" }} />
                    <Typography
                      variant="h5"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Acupuncture Treatment
                    </Typography>
                    <br />
                    <Typography
                      variant="overline"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Progress Inquiry
                    </Typography>
                    <br />
                    <Typography
                      variant="body1"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Treatment plan progress, patient’s reactions, document
                      Patient’s referral to follow recommendation,
                      contraindication, adjunct modalities/treatment or
                      procedures used.
                    </Typography>

                    <br />

                    <TextField
                      id="outlined-multiline-static"
                      onChange={this.handleInputChange}
                      label="Progress Inquiry"
                      multiline
                      rows={3}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant="outlined"
                      name="progInqu"
                      value={this.state.progInqu}
                    />
                    <br />
                    <br />
                    <Typography
                      variant="overline"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Examinations
                    </Typography>
                    <br />
                    <TextField
                      ref="areasOther"
                      label="Tongue"
                      id="margin-none"
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="tongue"
                      value={this.state.tongue}
                    />
                    <TextField
                      ref="areasOther"
                      label="Pulse"
                      id="margin-none"
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="Pulse"
                      value={this.state.Pulse}
                    />
                    <TextField
                      ref="areasOther"
                      label="Palpation"
                      id="margin-none"
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="Palpation"
                      value={this.state.Palpation}
                    />
                    <TextField
                      ref="areasOther"
                      label="General"
                      id="margin-none"
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="General"
                      value={this.state.General}
                    />

                    <br />
                    <br />
                    <Typography
                      variant="overline"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Revised Diagnosis and Treatment
                    </Typography>

                    <br />
                    <Typography
                      variant="body1"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      1.Revised TCM Diagnosis/Differentiations; 2.Revised TCM
                      Treatment Plan; 3.Revised Acupuncture Points Prescription;
                      4.Revised Herbal Prescription; 5. Adjunct Modalities
                    </Typography>

                    <br />

                    <TextField
                      ref="areasOther"
                      label="Notes"
                      id="margin-none"
                      multiline
                      rows={3}
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="revisedDiag"
                      value={this.state.revisedDiag}
                    />
                  </>
                )}
                <br />
                {this.state.acupunctureAssessment && (
                  <>
                    <hr style={{ opacity: "20%" }} />
                    <Typography
                      variant="h5"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Initial Acupuncture/TCM Assessment and Treatment Record
                    </Typography>
                    <br />
                    <Typography
                      variant="body1"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Chief Complaints and Duration
                    </Typography>
                    <br />

                    <TextField
                      id="outlined-multiline-static"
                      onChange={this.handleInputChange}
                      label="Chief Complaints"
                      multiline
                      rows={3}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant="outlined"
                      name="chiefComplaints"
                      value={this.state.chiefComplaints}
                    />
                    <br />
                    <Typography
                      variant="body1"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Current Illness/Symptoms (Energy, Sleep, Appetite, Diet,
                      Thirsty, Body Temperature, Sweating, Body Pains, Bowels,
                      Urine, Menstruations)
                    </Typography>

                    <br />

                    <TextField
                      id="outlined-multiline-static"
                      onChange={this.handleInputChange}
                      label="Current Illness"
                      multiline
                      rows={3}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant="outlined"
                      name="currentIllness"
                      value={this.state.currentIllness}
                    />
                    <br />
                    <Typography
                      variant="body1"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Medical History (Previous family health, ongoing problems,
                      past illness/operations, prescription drugs, allergies,
                      nutrition supplement, other health care provider’s
                      referral and /or treatments…)
                    </Typography>

                    <br />

                    <TextField
                      id="outlined-multiline-static"
                      onChange={this.handleInputChange}
                      label="Medical History"
                      multiline
                      rows={3}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant="outlined"
                      name="medicalHistory"
                      value={this.state.medicalHistory}
                    />
                    <br />
                    <br />
                    <Typography
                      variant="overline"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Examinations
                    </Typography>
                    <br />
                    <TextField
                      ref="areasOther"
                      label="Tongue: (Shape: thin, swollen, teethmark; Color: pale, red, purple, others; Coating: white, yellow, dry, greasy, others)"
                      id="margin-none"
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="tongueAssessment"
                      value={this.state.tongueAssessment}
                    />
                    <TextField
                      ref="areasOther"
                      label="Pulse: (general: floating, deep, slow, rapid, deficient, excessive, choppy, wiry, weak)"
                      id="margin-none"
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="PulseAssessment"
                      value={this.state.PulseAssessment}
                    />
                    <TextField
                      ref="areasOther"
                      label="Palpation"
                      id="margin-none"
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="PalpationAssessment"
                      value={this.state.PalpationAssessment}
                    />

                    <br />
                    <br />
                    <Typography
                      variant="overline"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Diagnosis and Treatment
                    </Typography>

                    <br />
                    <Typography
                      variant="body1"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      TCM Diagnosis and Differentiations:
                    </Typography>

                    <br />
                    <TextField
                      ref="areasOther"
                      label="Notes"
                      id="margin-none"
                      multiline
                      rows={3}
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="tcmDiagnosis"
                      value={this.state.tcmDiagnosis}
                    />
                    <br />
                    <Typography
                      variant="body1"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      TCM Treatment Principles:{" "}
                    </Typography>

                    <br />
                    <TextField
                      ref="areasOther"
                      label="Notes"
                      id="margin-none"
                      multiline
                      rows={3}
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="tcmTreatment"
                      value={this.state.tcmTreatment}
                    />
                    <br />
                    <Typography
                      variant="body1"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Treatment Plan/Advice
                    </Typography>

                    <br />
                    <TextField
                      ref="areasOther"
                      label="Notes"
                      id="margin-none"
                      multiline
                      rows={3}
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="treatmentPlan"
                      value={this.state.treatmentPlan}
                    />
                    <br />
                    <Typography
                      variant="body1"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Acupuncture Points Prescription, Technique, Retention
                    </Typography>

                    <br />
                    <TextField
                      ref="areasOther"
                      label="Notes"
                      id="margin-none"
                      multiline
                      rows={3}
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="acupuncturePointsPrescription"
                      value={this.state.acupuncturePointsPrescription}
                    />
                    <br />
                    <Typography
                      variant="body1"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Herbal Prescription: Formula Name & Dosage; Type:
                      Ingredients of Granule herbs& Dosage& Frequency;
                      Instructions for preparation and consumption{" "}
                    </Typography>

                    <br />

                    <TextField
                      ref="areasOther"
                      label="Notes"
                      id="margin-none"
                      multiline
                      rows={3}
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="herbal"
                      value={this.state.herbal}
                    />

                    <br />
                    <Typography
                      variant="body1"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Adjunct Modalities: Cupping, Exercise, Dietary therapy,
                      Tui Na Therapy, others
                    </Typography>

                    <br />
                    <TextField
                      ref="areasOther"
                      label="Notes"
                      id="margin-none"
                      multiline
                      rows={3}
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="adjunctModalities"
                      value={this.state.adjunctModalities}
                    />
                  </>
                )}
                <br />
                <br />
                {this.state.osteoAssessment && (
                  <>
                    <hr style={{ opacity: "20%" }} />
                    <Typography
                      variant="h5"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Osteopathy and Massage Assessment
                    </Typography>
                    <br />

                    <Typography
                      variant="body1"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Limitations of activities of daily living
                    </Typography>

                    <br />
                    <TextField
                      id="outlined-multiline-static"
                      onChange={this.handleInputChange}
                      label="Notes"
                      multiline
                      rows={3}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant="outlined"
                      name="limitations"
                      value={this.state.limitations}
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.treatmentDiscussed}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="treatmentDiscussed"
                          value={this.state.treatmentDiscussed}
                        />
                      }
                      label="Treatment plan discussed with Client"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.receivedConsent}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="receivedConsent"
                          value={this.state.receivedConsent}
                        />
                      }
                      label="Received informed consent for treatment plan"
                    />
                    <br />
                    <Typography
                      variant="overline"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Clients Goal / Treatment Goal:
                    </Typography>
                    <br />
                    <TextField
                      id="outlined-multiline-static"
                      onChange={this.handleInputChange}
                      label="Notes"
                      multiline
                      rows={3}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant="outlined"
                      name="treatmentGoal"
                      value={this.state.treatmentGoal}
                    />

                    <Typography
                      variant="body1"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Type / Focus of treatment:
                    </Typography>

                    <br />

                    <TextField
                      id="outlined-multiline-static"
                      onChange={this.handleInputChange}
                      label="Notes"
                      multiline
                      rows={3}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant="outlined"
                      name="typeTreatment"
                      value={this.state.typeTreatment}
                    />
                    <br />
                    <br />
                    <Typography
                      variant="body1"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Frequency and Duration
                    </Typography>
                    <br />
                    <TextField
                      ref="areasOther"
                      label="Notes"
                      id="margin-none"
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="frequencyAssessment"
                      multiline
                      rows={3}
                      value={this.state.frequencyAssessment}
                    />
                    <Typography
                      variant="body1"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Assessments Performed
                    </Typography>
                    <TextField
                      ref="areasOther"
                      label="Notes"
                      id="margin-none"
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="assessmentsPerformed"
                      multiline
                      rows={3}
                      value={this.state.assessmentsPerformed}
                    />
                    <br />
                    <Typography
                      variant="body1"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Anticipated Progression of Responses:
                    </Typography>
                    <TextField
                      ref="areasOther"
                      label="Notes"
                      id="margin-none"
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="anticipatedProgress"
                      multiline
                      rows={3}
                      value={this.state.anticipatedProgress}
                    />

                    <br />

                    <Typography
                      variant="body1"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Results of Assessments:
                    </Typography>
                    <TextField
                      ref="areasOther"
                      label="Notes"
                      id="margin-none"
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="resultsOfAssessment"
                      multiline
                      rows={3}
                      value={this.state.resultsOfAssessment}
                    />

                    <br />
                    <Typography
                      variant="body1"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Remedial exercises/ Hydrotherapy recommended:
                    </Typography>
                    <TextField
                      ref="areasOther"
                      label="Notes"
                      id="margin-none"
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="remedialExercises"
                      multiline
                      rows={3}
                      value={this.state.remedialExercises}
                    />

                    <br />
                    <Typography
                      variant="body1"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Reassessment schedule:
                    </Typography>
                    <TextField
                      ref="areasOther"
                      label="Notes"
                      id="margin-none"
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="reassessment"
                      multiline
                      rows={3}
                      value={this.state.reassessment}
                    />

                    <br />
                    <Typography
                      variant="body1"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Contraindications / Risks:
                    </Typography>
                    <TextField
                      ref="areasOther"
                      label="Notes"
                      id="margin-none"
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ marginBottom: 20, marginTop: 10, width: "100%" }}
                      variant={"outlined"}
                      name="risksAssessment"
                      multiline
                      rows={3}
                      value={this.state.risksAssessment}
                    />

                    <br />
                    <Typography
                      variant="body1"
                      style={{ textAlign: "left", marginTop: 20 }}
                    >
                      Areas Treated
                    </Typography>
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.backAssessment}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="backAssessment"
                          value={this.state.backAssessment}
                        />
                      }
                      label="back"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.neckAssessment}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="neckAssessment"
                          value={this.state.neckAssessment}
                        />
                      }
                      label="neck"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.shouldersAssessment}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="shouldersAssessment"
                          value={this.state.shouldersAssessment}
                        />
                      }
                      label="shoulders"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.faceAssessment}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="faceAssessment"
                          value={this.state.faceAssessment}
                        />
                      }
                      label="face"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.leftArmAssessment}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="leftArmAssessment"
                          value={this.state.leftArmAssessment}
                        />
                      }
                      label="Left Arm"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.rightArmAssessment}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="rightArmAssessment"
                          value={this.state.rightArmAssessment}
                        />
                      }
                      label="Right Arm"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.leftLegAssessment}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="leftLegAssessment"
                          value={this.state.leftLegAssessment}
                        />
                      }
                      label="Left Leg"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.rightLegAssessment}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="rightLegAssessment"
                          value={this.state.rightLegAssessment}
                        />
                      }
                      label="Right Leg"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.gluteusAssessment}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="gluteusAssessment"
                          value={this.state.gluteusAssessment}
                        />
                      }
                      label="gluteus"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.abdominalsAssessment}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="abdominalsAssessment"
                          value={this.state.abdominalsAssessment}
                        />
                      }
                      label="abdominals (visceral)"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.chestAssessment}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="chestAssessment"
                          value={this.state.chestAssessment}
                        />
                      }
                      label="chest"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.breastAssessment}
                          onChange={this.handleCheckBoxChange}
                          color="primary"
                          name="breastAssessment"
                          value={this.state.breastAssessment}
                        />
                      }
                      label="breast"
                    />
                    <br />

                    <TextField
                      ref="areasOther"
                      label="Other"
                      id="margin-none"
                      className="areasOther"
                      onChange={this.handleInputChange}
                      style={{ width: "100%" }}
                      variant={"outlined"}
                      name="areasOtherAssessment"
                      value={this.state.areasOtherAssessment}
                    />
                  </>
                )}
                <hr style={{ opacity: "20%" }} />
                <br />
                {!this.state.canSubmit && (
                  <div
                    style={{
                      padding: 20,
                      border: "1px solid #F2994A",
                      backgroundColor: "#FCEBDB",
                      borderRadius: 5,
                    }}
                  >
                    <Typography variant="h6" style={{ textAlign: "left" }}>
                      No Submission Access
                    </Typography>
                    <Typography
                      variant="body2"
                      style={{ textAlign: "left", marginTop: 10 }}
                    >
                      As a user, you cannot edit existing treatment notes. If
                      you would like to make changes, please contact the clinic
                      administrators.
                    </Typography>
                  </div>
                )}
                <Button
                  style={{
                    marginTop: 30,
                    width: 120,
                    borderRadius: 20,
                    marginRight: 10,
                    color: "002BB8",
                  }}
                  type="submit"
                  variant="outlined"
                  disabled={!this.state.canSubmit}
                  disableElevation
                  color="primary"
                  onClick={this.handleSubmit(false)}
                >
                  Save
                </Button>
                <Button
                  style={{
                    marginTop: 30,
                    width: 120,
                    borderRadius: 20,
                    color: "002BB8",
                  }}
                  type="submit"
                  variant="contained"
                  disabled={this.state.locked || !this.state.canSubmit}
                  disableElevation
                  color="primary"
                  onClick={this.handleSubmit(true)}
                >
                  Submit!
                </Button>
                {this.props.admin &&
                  this.props.admin.permissions === "Administrator" && (
                    <div
                      style={{
                        position: "fixed",
                        bottom: "40px",
                        right: "40px",
                        zIndex: 1000,
                      }}
                    >
                      <Button
                        style={{
                          width: 56,
                          height: 56,
                          borderRadius: "50%",
                          backgroundColor: "#002BB8",
                          color: "#fff",
                          minWidth: "unset",
                          padding: 0,
                          boxShadow:
                            "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)",
                        }}
                        variant="contained"
                        disableElevation={false}
                        onClick={this.generatePdf}
                      >
                        <GetAppIcon />
                      </Button>
                    </div>
                  )}
              </Grid>
              <hr style={{ opacity: "20%" }} />
              <br />
              {this.state.submissionHistory &&
                this.state.submissionHistory.length > 0 && (
                  <div
                    style={{ marginTop: 20, marginBottom: 20, width: "100%" }}
                  >
                    {this.state.submissionHistory.map((submission, index) => (
                      <Typography
                        key={index}
                        variant="body2"
                        style={{
                          textAlign: "left",
                          marginTop: 5,
                          color: "#757575",
                        }}
                      >
                        Submission {index + 1}:{" "}
                        {submission.submitter || "Unknown"} -{" "}
                        {new Date(submission.submissionTime).toLocaleString()}
                      </Typography>
                    ))}
                    {this.state.locked && (
                      <Typography
                        variant="body2"
                        style={{
                          textAlign: "left",
                          marginTop: 5,
                          color: "#757575",
                        }}
                      >
                        Locked on Submission.
                      </Typography>
                    )}
                  </div>
                )}
            </Grid>
          </ThemeProvider>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    patients: state.patients,
    visits: state.visits,
    admin: state.admin,
  };
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    fetchVisits,
    fetchPatients,
    fetchAdmins,
  })
)(withRouter(TreatmentNotes));
